const header = (url, key) => `//+------------------------------------------------------------------+
//| TradePulse Auto-Sync EA                                          |
//| Sends your closed trades to your TradePulse journal every minute.|
//| Read-only: this EA never opens, modifies or closes trades.       |
//| Setup: Tools > Options > Expert Advisors > tick "Allow WebRequest|
//| for listed URL" and add: ${url}
//+------------------------------------------------------------------+
#property strict
input string InpApiUrl  = "${url}/api/sync/trades";
input string InpSyncKey = "${key}";
input int    InpDaysBack = 90;
input int    InpIntervalSec = 60;

datetime g_since = 0;

string Esc(string s) { StringReplace(s, "\\\\", ""); StringReplace(s, "\\"", ""); return s; }

long GmtOffset(datetime serverNow) { return (long)MathRound((double)(serverNow - TimeGMT()) / 900.0) * 900; }

string PingUrl() { string u = InpApiUrl; StringReplace(u, "/sync/trades", "/sync/ping"); return u; }

bool Post(string url, string json)
{
   char data[], result[];
   string resHeaders;
   StringToCharArray(json, data, 0, WHOLE_ARRAY, CP_UTF8);
   ArrayResize(data, ArraySize(data) - 1);
   string headers = "Content-Type: application/json\\r\\nX-Sync-Key: " + InpSyncKey + "\\r\\n";
   ResetLastError();
   int code = WebRequest("POST", url, headers, 10000, data, result, resHeaders);
   if(code == -1) { Print("TradePulse: WebRequest failed (", GetLastError(), "). Add the URL in Tools > Options > Expert Advisors."); return false; }
   Print("TradePulse sync: HTTP ", code, " ", CharArrayToString(result));
   return code == 200;
}

int OnInit()
{
   g_since = TimeCurrent() - InpDaysBack * 86400;
   string info = InfoJson();
   Print("TradePulse: starting live test ", info);
   if(!Post(PingUrl(), "{" + info + "}")) Print("TradePulse: live test FAILED - check the Allowed URL and sync key.");
   EventSetTimer(InpIntervalSec);
   SyncNow();
   return INIT_SUCCEEDED;
}

void OnDeinit(const int reason) { EventKillTimer(); }
void OnTimer() { SyncNow(); }
`;

const mt5Body = `
string InfoJson()
{
   int hist = HistorySelect(0, TimeCurrent() + 86400) ? HistoryDealsTotal() : 0;
   return "\\"platform\\":\\"MT5\\",\\"build\\":" + IntegerToString(TerminalInfoInteger(TERMINAL_BUILD)) +
          ",\\"login\\":\\"" + IntegerToString(AccountInfoInteger(ACCOUNT_LOGIN)) + "\\",\\"server\\":\\"" + Esc(AccountInfoString(ACCOUNT_SERVER)) +
          "\\",\\"company\\":\\"" + Esc(AccountInfoString(ACCOUNT_COMPANY)) + "\\",\\"gmt_offset\\":" + IntegerToString(GmtOffset(TimeTradeServer())) +
          ",\\"history_total\\":" + IntegerToString(hist);
}

void SyncNow()
{
   long offset = GmtOffset(TimeTradeServer());
   datetime now = TimeCurrent();
   if(!HistorySelect(0, now + 86400)) return;
   int total = HistoryDealsTotal();
   string items = "";
   int count = 0;
   for(int i = 0; i < total; i++)
   {
      ulong deal = HistoryDealGetTicket(i);
      if(HistoryDealGetInteger(deal, DEAL_ENTRY) != DEAL_ENTRY_OUT) continue;
      datetime closeTime = (datetime)HistoryDealGetInteger(deal, DEAL_TIME);
      if(closeTime < g_since) continue;
      long dtype = HistoryDealGetInteger(deal, DEAL_TYPE);
      if(dtype != DEAL_TYPE_BUY && dtype != DEAL_TYPE_SELL) continue;
      long posId = HistoryDealGetInteger(deal, DEAL_POSITION_ID);
      double openPrice = 0; datetime openTime = closeTime;
      for(int j = 0; j < total; j++)
      {
         ulong d2 = HistoryDealGetTicket(j);
         if(HistoryDealGetInteger(d2, DEAL_POSITION_ID) == posId && HistoryDealGetInteger(d2, DEAL_ENTRY) == DEAL_ENTRY_IN)
         { openPrice = HistoryDealGetDouble(d2, DEAL_PRICE); openTime = (datetime)HistoryDealGetInteger(d2, DEAL_TIME); break; }
      }
      double pnl = HistoryDealGetDouble(deal, DEAL_PROFIT) + HistoryDealGetDouble(deal, DEAL_COMMISSION) + HistoryDealGetDouble(deal, DEAL_SWAP);
      string side = (dtype == DEAL_TYPE_SELL) ? "buy" : "sell";
      if(count > 0) items += ",";
      items += "{\\"ticket\\":\\"" + IntegerToString((long)deal) + "\\",\\"symbol\\":\\"" + Esc(HistoryDealGetString(deal, DEAL_SYMBOL)) +
               "\\",\\"side\\":\\"" + side + "\\",\\"lots\\":" + DoubleToString(HistoryDealGetDouble(deal, DEAL_VOLUME), 2) +
               ",\\"open_price\\":" + DoubleToString(openPrice, 6) + ",\\"close_price\\":" + DoubleToString(HistoryDealGetDouble(deal, DEAL_PRICE), 6) +
               ",\\"open_time\\":" + IntegerToString((long)openTime - offset) + ",\\"close_time\\":" + IntegerToString((long)closeTime - offset) +
               ",\\"pnl\\":" + DoubleToString(pnl, 2) + "}";
      count++;
   }
   string json = "{\\"balance\\":" + DoubleToString(AccountInfoDouble(ACCOUNT_BALANCE), 2) + ",\\"trades\\":[" + items + "]}";
   Print("TradePulse: sending ", count, " closed trades");
   if(Post(InpApiUrl, json)) g_since = now - 86400;
}
`;

const mt4Body = `
string InfoJson()
{
   return "\\"platform\\":\\"MT4\\",\\"build\\":" + IntegerToString(TerminalInfoInteger(TERMINAL_BUILD)) +
          ",\\"login\\":\\"" + IntegerToString(AccountNumber()) + "\\",\\"server\\":\\"" + Esc(AccountServer()) +
          "\\",\\"company\\":\\"" + Esc(AccountCompany()) + "\\",\\"gmt_offset\\":" + IntegerToString(GmtOffset(TimeCurrent())) +
          ",\\"history_total\\":" + IntegerToString(OrdersHistoryTotal());
}

void SyncNow()
{
   long offset = GmtOffset(TimeCurrent());
   datetime now = TimeCurrent();
   string items = "";
   int count = 0;
   for(int i = OrdersHistoryTotal() - 1; i >= 0; i--)
   {
      if(!OrderSelect(i, SELECT_BY_POS, MODE_HISTORY)) continue;
      int type = OrderType();
      if(type != OP_BUY && type != OP_SELL) continue;
      if(OrderCloseTime() < g_since) continue;
      double pnl = OrderProfit() + OrderCommission() + OrderSwap();
      if(count > 0) items += ",";
      items += "{\\"ticket\\":\\"" + IntegerToString(OrderTicket()) + "\\",\\"symbol\\":\\"" + Esc(OrderSymbol()) +
               "\\",\\"side\\":\\"" + (type == OP_BUY ? "buy" : "sell") + "\\",\\"lots\\":" + DoubleToString(OrderLots(), 2) +
               ",\\"open_price\\":" + DoubleToString(OrderOpenPrice(), 6) + ",\\"close_price\\":" + DoubleToString(OrderClosePrice(), 6) +
               ",\\"open_time\\":" + IntegerToString((long)OrderOpenTime() - offset) + ",\\"close_time\\":" + IntegerToString((long)OrderCloseTime() - offset) +
               ",\\"pnl\\":" + DoubleToString(pnl, 2) + "}";
      count++;
   }
   if(OrdersHistoryTotal() == 0) Print("TradePulse: Account History is empty. Right-click Account History > All History.");
   string json = "{\\"balance\\":" + DoubleToString(AccountBalance(), 2) + ",\\"trades\\":[" + items + "]}";
   Print("TradePulse: sending ", count, " closed trades");
   if(Post(InpApiUrl, json)) g_since = now - 86400;
}
`;

export function buildEA(platform, url, key) {
  return header(url, key) + (platform === "mt4" ? mt4Body : mt5Body);
}
